// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_80ad21f8ef--wrapper--rKuh1","content":"_80ad21f8ef--content--v4obX"};